/* eslint-disable */
"use client";

import useCognito from "@/components/terra/component/ExternalForm/useCognito";
import useMarketo from "@/components/terra/component/ExternalForm/useMarketo";
import { useNinetailed } from "@ninetailed/experience.js-react";
import { Icon, IconType } from "@/components/formatters/MXPIcon";
import { CommonDescription } from "../CommonDescription/CommonDescription";
import { useId, useState } from "react";
import { pushFormSubmitSuccess } from "@/components/client/Datalayer/utilities";
import "./ExternalForm.css";
import "./CognitoForm.css";
import "./MarketoForm.css";
export interface ExternalFormProps {
  eyebrow?: string;
  header?: string;
  subheader?: string;
  description?: string;
  formType: "Cognito" | "HubSpot" | "Marketo";
  cognitoInstance?: string;
  marketoDomain?: string;
  marketoInstance?: string;
  followUpUrl?: string;
  followUpMessage?: string;
  formId: string;
  setModalIsOpen?: any;
  emailFieldAutoPop?: string;
  backgroundTheme?: string;
  buttonDisabled?: boolean;
  calendlyId?: string;
  calendlyUrl?: string;
  prefillData?: Record<string, unknown>;
}
export const ExternalForm = ({
  eyebrow,
  header,
  subheader,
  description,
  formType,
  cognitoInstance,
  marketoDomain,
  marketoInstance,
  followUpUrl,
  followUpMessage,
  formId,
  setModalIsOpen,
  emailFieldAutoPop,
  backgroundTheme,
  buttonDisabled = false,
  calendlyId,
  calendlyUrl,
  prefillData
}: ExternalFormProps) => {
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const followUp = followUpUrl && followUpUrl !== "" ? true : false;
  const {
    track
  } = useNinetailed();
  // A single Cognito `formId` can be referenced by more than one layout
  // section on the same page (e.g. the same newsletter signup form embedded
  // in several places). DOM ids must be unique per element, so derive a
  // per-instance id here rather than mounting every instance at
  // `#cognitoForm_<formId>` — otherwise all instances collide on the first
  // matching element and only one (if any) actually mounts.
  const instanceId = useId().replace(/:/g, "");
  const cognitoElementId = `cognitoForm_${formId}_${instanceId}`;
  function triggerFormSubmitSuccess(formName: string, formValues: Record<string, any>) {
    if (formName && typeof formValues === "object" && formValues !== null) {
      pushFormSubmitSuccess({
        formName,
        formType: "external_form",
        formProvider: formType,
        formId,
        formData: formValues
      });
    }
  }
  const successCallback = (values: any) => {
    setSubmitSuccess(true);
    track("form_submit", {
      form_name: formId
    });
    if (followUp) {
      window.location.replace(`${followUpUrl}`);
      window.location.href = `${followUpUrl}`;
      triggerFormSubmitSuccess(formId, values);
    }
    return false;
  };
  if (formType == "Cognito") {
    useCognito({
      formId: formId,
      cognitoInstance: cognitoInstance,
      followUpUrl,
      calendlyId: calendlyId ?? null,
      calendlyUrl: calendlyUrl ?? null,
      onSuccessCallback: successCallback,
      onTrackFormSubmit: () => track("form_submit", {
        form_name: formId
      }),
      prefillData,
      elementId: cognitoElementId
    });
  } else if (formType == "Marketo") {
    useMarketo({
      formId: formId,
      marketoDomain: marketoDomain,
      marketoInstance: marketoInstance,
      followUpUrl,
      onSuccessCallback: successCallback,
      onTrackFormSubmit: () => track("form_submit", {
        form_name: formId
      })
    });
  } else if (formType == "HubSpot") {
    // TODO
  }
  return <div className="t2-form-modal">
      <div className={`t2-form-modal__inner ${backgroundTheme ? backgroundTheme : "t2-color-setting--light"}`}>
        {buttonDisabled === false && <button className={`t2-form-modal__close-button`} onClick={() => setModalIsOpen(false)}>
            Close
            <span className="t2-form-modal__close-button-icon">
              <Icon type="t2-icon--open-x-dark-16px" size={14} />
            </span>
          </button>}
        {(eyebrow || header || subheader || description) && <div className="formTopContent mb-10">
            <div className="formTopContent__eyebrow">{eyebrow}</div>
            <div className="formTopContent__header">{header}</div>
            <div className="formTopContent__subheader">{subheader}</div>
            {description && <CommonDescription description={description} className={"formTopContent__description t2-layout__description"} />}
          </div>}
        {formType == "Cognito" && <div>
            <div className="cognito" id={cognitoElementId}></div>
          </div>}
        {formType == "Marketo" && <div>
            <form id={`mktoForm_${formId}`}></form>
          </div>}
        {formType == "HubSpot" && <div>Hubspot TODO</div>}
        {formType !== "Cognito" && formType !== "Marketo" && formType !== "HubSpot" && <div>Invalid Form Type</div>}
        <div className={`form__followUpMessage ${submitSuccess === true ? "form__followUpMessage--active" : ""}`}>
          <CommonDescription description={followUpMessage} />
        </div>
      </div>
    </div>;
};